<template>
  <v-list-item-content>
    <v-list-item-title>
      <small class='grey--text'>{{ account.number }}</small>
      {{ account.name }}
    </v-list-item-title>
    <v-list-item-subtitle v-if='account.grouping' class='grey--text'>{{ account.grouping }}</v-list-item-subtitle>
  </v-list-item-content>
</template>

<script>
export default {
  name: 'account-picker-list-item',
  props: {
    account: {
      required: true
    }
  }
}
</script>
